import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { EDMUNDS_LOGO_NO_TEXT } from 'client/images/inline-svgs/edmunds-logo';
import { CANVAS_ICONS } from 'site-modules/canvas/constants/canvas';

import './start-screen-header.scss';

export function StartScreenHeader({ copyClasses, className = null }) {
  return (
    <div
      className={classnames(
        'start-screen-header d-flex flex-column justify-content-center align-items-center',
        className
      )}
    >
      <div className="pos-r">
        <EDMUNDS_LOGO_NO_TEXT width={40} classes="logo flex-shrink-0" />
        <img
          className="sparkle pos-a"
          src={CANVAS_ICONS.RED_SPARKLE}
          width={13}
          height={13}
          alt="Ask AI"
          loading="lazy"
        />
      </div>
      <h1 className={classnames('header-copy fw-bold mt-1 text-center', copyClasses)}>
        Your Co-Driver for smarter decisions.
      </h1>
    </div>
  );
}

StartScreenHeader.propTypes = {
  copyClasses: PropTypes.string,
  className: PropTypes.string,
};
